import { Interface } from '@ethersproject/abi'
import REWARDS_V2_ABI  from './rewards-V2.json'

const REWARDS_V2_INTERFACE = new Interface(REWARDS_V2_ABI)

export { REWARDS_V2_INTERFACE }
